import api from './axios';

export const fetchBookmarkIds = () => api.get('/client/bookmarks/ids').then((r) => r.data);

export const fetchBookmarks = (params) => api.get('/client/bookmarks', { params }).then((r) => r.data);

export const addBookmark = (tenantId) => api.post('/client/bookmarks', { tenantId }).then((r) => r.data);

export const removeBookmark = (tenantId) =>
  api.delete(`/client/bookmarks/${tenantId}`).then((r) => r.data);
